import TourPackage from '@/components/TourPackage'


export default function TourPackagePage() {
  return (
    <div>
      <TourPackage/>
    </div>
  )
}
